/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectAnalyticsRequestDateRange
 */
export interface ProjectAnalyticsRequestDateRange {
    /**
     * 
     * @type {Date}
     * @memberof ProjectAnalyticsRequestDateRange
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProjectAnalyticsRequestDateRange
     */
    to?: Date;
}

/**
 * Check if a given object implements the ProjectAnalyticsRequestDateRange interface.
 */
export function instanceOfProjectAnalyticsRequestDateRange(value: object): value is ProjectAnalyticsRequestDateRange {
    return true;
}

export function ProjectAnalyticsRequestDateRangeFromJSON(json: any): ProjectAnalyticsRequestDateRange {
    return ProjectAnalyticsRequestDateRangeFromJSONTyped(json, false);
}

export function ProjectAnalyticsRequestDateRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectAnalyticsRequestDateRange {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'] == null ? undefined : (new Date(json['from'])),
        'to': json['to'] == null ? undefined : (new Date(json['to'])),
    };
}

export function ProjectAnalyticsRequestDateRangeToJSON(value?: ProjectAnalyticsRequestDateRange | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'from': value['from'] == null ? undefined : ((value['from']).toISOString().substring(0,10)),
        'to': value['to'] == null ? undefined : ((value['to']).toISOString().substring(0,10)),
    };
}

